module.exports = __webpack_public_path__ + "static/logo-b134463efe8b15b64f63f5e67549a818.jpg";